// B2INST-specific normalisation helpers.
// The generic ExternalRecordSearchModal accepts these as props so it stays
// independent of B2INST internals.

/**
 * Convert a normalised B2INST hit to the B2SHARE instrument draft field shape.
 * Throws if the hit has no valid Handle identifier.
 */
export const toB2ShareInstrument = (hit) => {
  const instrument = hit?.instrument;
  if (
    !instrument ||
    !instrument.instrument_name ||
    !instrument.identifier ||
    instrument.scheme !== "handle"
  ) {
    throw new Error("The selected record has no valid Handle identifier.");
  }
  return {
    instrument_name: instrument.instrument_name,
    identifier: instrument.identifier,
    scheme: "handle",
  };
};

/**
 * Return true if the Handle identifier already exists in the instrument list.
 */
export const isInstrumentDuplicate = (existingItems, hit) => {
  const identifier = hit?.instrument?.identifier;
  if (!identifier) return false;
  return (existingItems || []).some(
    (i) =>
      i?.scheme?.toLowerCase() === "handle" && i?.identifier === identifier
  );
};

/**
 * Remove filter keys no longer present in the current facet list.
 */
export const reconcileFilters = (filters, facets) => {
  const available = new Set((facets || []).map((f) => f.name));
  return Object.fromEntries(
    Object.entries(filters || {}).filter(([name]) => available.has(name))
  );
};
